import type { CardHooks } from "./registry";

/**
 * Pocket Sand — Utility / Reaction.
 *
 * Trigger (gated by reactionTriggers data in Supabase):
 *   opponent-plays-attack
 *
 * Keywords: ["Negate"]
 *   The Negate keyword is handled by playtestEngine.ts. When Pocket Sand
 *   resolves, the engine first calls negateLastOpponentChainEntry, which:
 *     • removes the attack's combat slot
 *     • refunds the attacker's stamina cost
 *     • restores priority to the attacker with subPhase "aggressor-pre-attack"
 *     • closes the action chain
 *
 * Card-specific effect (this hook):
 *   AFTER the negate has cleared the attack, Pocket Sand flips the combat
 *   roles — the player who threw the sand becomes the new aggressor.
 *   This mirrors Scenario 3 of resolveCombat (defender full-blocks with
 *   Stun): the role-flip IS the stun's consumption, so we do NOT leave a
 *   `stunned: true` marker on the original attacker. They become defender
 *   and should be free to play a normal defend on the upcoming attack.
 *
 *   Earlier versions also set `opponentPatch: { stunned: true }` here,
 *   which caused the original attacker's defense to be force-skipped on
 *   the Pocket-Sand player's follow-up attack (confirmPendingPlay treats
 *   stunned defenders as forced armor-block / take-damage). Removing it
 *   matches Noah's design: "The stun is consumed when I become the
 *   aggressor because him being stunned is what gives me priority and
 *   aggressor."
 *
 * Implementation note:
 *   `becomeAggressor: true` asks the engine to flip roles and hand
 *   priority to us. This is a generic capability on CardHookResult, not
 *   bound to Pocket Sand — future cards can reuse it.
 */
export const pocketSand: CardHooks = {
  onUtilityPlay: (_ctx) => {
    return {
      becomeAggressor: true,
      log: [
        "Pocket Sand — attack negated, attacker forced to defend.",
      ],
    };
  },
};
